import React, { useState } from 'react';
import { 
  getTeacherSubjects, 
  getTeacherECAs, 
  getTeacherCommittees, 
  getTeacherDuties,
  getTeacherDisplayName,
  getTeacherTitle,
  getTeacherInitials
} from './TeacherDirectoryHelpers';
import TimetableView from '../Timetable/TimetableView';

export const TeacherDetailModal = ({ teacher, classes, onClose }) => {
  const [showTimetable, setShowTimetable] = useState(false);

  if (!teacher) return null;

  // Find classes where this teacher is class master or vice class master
  const teacherClasses = classes.filter(cls => 
    cls.class_master === teacher.teacher_id || cls.vice_class_master === teacher.teacher_id
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>教師詳細資料</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          <div className="teacher-profile">
            <div className="teacher-avatar-large">
              {teacher.avatar ? (
                <img src={teacher.avatar} alt={getTeacherDisplayName(teacher)} />
              ) : (
                <div className="avatar-placeholder-large">
                  {getTeacherInitials(teacher)}
                </div>
              )}
            </div>
            
            <div className="teacher-details">
              <h3>{getTeacherDisplayName(teacher)}</h3>
              <p><strong>職位:</strong> {getTeacherTitle(teacher)}</p>
              <p><strong>部門:</strong> {teacher.department}</p>
              <p><strong>狀態:</strong> 
                <span className={`status-badge ${teacher.status === 'active' ? 'active' : 'inactive'}`}>
                  {teacher.status === 'active' ? '在職' : '離職'}
                </span>
              </p>
            </div>
          </div>

          <div className="contact-info">
            <h4>聯絡資料</h4>
            <p><strong>電郵:</strong> {teacher.email}</p>
            <p><strong>電話:</strong> {teacher.phone || '未提供'}</p>
            <p><strong>辦公室:</strong> {teacher.office || '未提供'}</p>
          </div>

          <div className="teaching-info">
            <h4>任教班別</h4>
            {teacherClasses.length > 0 ? (
              <div className="classes-list">
                {teacherClasses.map(cls => (
                  <div key={cls.class_id} className="class-item">
                    <span className="class-name">{cls.name}</span>
                    <span className="class-grade">{cls.grade}</span>
                  </div>
                ))}
              </div>
            ) : (
              <p>目前沒有任教班別</p>
            )}
          </div>

          {/* Extended Information Sections */}
          {getTeacherSubjects(teacher).length > 0 && (
            <div className="teacher-subjects">
              <h4>任教科目</h4>
              <div className="subjects-list">
                {getTeacherSubjects(teacher).map((subject, index) => (
                  <span key={index} className="subject-tag">{subject}</span>
                ))}
              </div>
            </div>
          )}

          {getTeacherECAs(teacher).length > 0 && (
            <div className="teacher-ecas">
              <h4>課外活動負責</h4>
              <div className="ecas-list">
                {getTeacherECAs(teacher).map((eca, index) => (
                  <span key={index} className="eca-tag">{eca}</span>
                ))}
              </div>
            </div>
          )}

          {getTeacherCommittees(teacher).length > 0 && (
            <div className="teacher-committees">
              <h4>委員會服務</h4>
              <div className="committees-list">
                {getTeacherCommittees(teacher).map((committee, index) => (
                  <span key={index} className="committee-tag">{committee}</span>
                ))}
              </div>
            </div>
          )}

          {getTeacherDuties(teacher).length > 0 && (
            <div className="teacher-duties">
              <h4>學校職責</h4>
              <div className="duties-list">
                {getTeacherDuties(teacher).map((duty, index) => (
                  <span key={index} className="duty-tag">{duty}</span>
                ))}
              </div>
            </div>
          )}

          {teacher.bio && (
            <div className="teacher-bio">
              <h4>簡介</h4>
              <p>{teacher.bio}</p>
            </div>
          )}

          {teacher.qualifications && (
            <div className="teacher-qualifications">
              <h4>資歷</h4>
              <ul>
                {teacher.qualifications.map((qual, index) => (
                  <li key={index}>{qual}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button 
            className="btn btn-primary" 
            onClick={() => setShowTimetable(!showTimetable)}
            style={{ marginRight: '8px' }}
          >
            {showTimetable ? '隱藏時間表' : '查看時間表'}
          </button>
          <button className="btn btn-secondary" onClick={onClose}>
            關閉
          </button>
        </div>

        {/* Timetable Section */}
        {showTimetable && (
          <div className="modal-timetable-section">
            <TimetableView
              type="teacher"
              entityId={teacher.teacher_id}
              entityName={getTeacherDisplayName(teacher)}
              onClose={() => setShowTimetable(false)}
              showCloseButton={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};
